import { Popover, TextField } from '@mui/material'
import useStyles from './styles'
import React, { useRef, useState } from 'react'
import { ExtraSmallButton } from '../../../custom'

export type NumberSelectorProps = {
    value: number,
    onChange: (value: number) => void,
    range?: number[],
    compact?: boolean,
    valueRenderer?: (value: number) => string
}

const NumberSelector: React.FC<NumberSelectorProps> = ({ value, compact = false, onChange, valueRenderer, range }) => {
    const { classes, cx } = useStyles()
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)
    const minVal = (range && range.length > 0) ? range[0] : -Infinity
    const maxVal = (range && range.length > 1) ? range[1] : Infinity
    const [error, setError] = useState(false)

    const ref = useRef<HTMLDivElement>(null)

    const input = <TextField size="small" value={value} type="number" error={error}
                             helperText={error ? `Enter within range (${minVal}, ${maxVal})` : undefined} autoFocus
                             onChange={(e) => {
                                 let num = Number(e.target.value)
                                 if (num <= maxVal && num >= minVal) {
                                     setError(false)
                                 } else {
                                    if(num < minVal) {
                                        num = minVal
                                    } else {
                                        num = maxVal
                                    }
                                    setError(true)
                                 }
                                 onChange(num)
                             }} />

    return <div ref={ref}>
        {!compact && input}
        {compact && <><ExtraSmallButton className={cx(classes.container, {
            [classes.compact]: compact
        })}
                                        onClick={() => setAnchorEl(ref.current)}>
            <div className={classes.value}>{valueRenderer ? valueRenderer(value) : value}</div>
        </ExtraSmallButton>
            <Popover
                elevation={3}
                open={Boolean(anchorEl)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                sx={{ display: 'flex', flexDirection: 'column', padding: 1.5 }}
            >
                {input}
            </Popover></>
        }
    </div>
}

export default NumberSelector

